<div class="priority-details">
  <h2 *ngIf="priority.value.id !== 0 || editMode">
    <span id="icon" class="material-icons-outlined">error</span>
    <span class="title-details">{{ priorityTitle | translate }}</span>
  </h2>

  <div *ngIf="priority.value.id === 0 && !editMode" class="empty-details">
    <span class="material-icons-outlined">error</span>
  </div>

  <div
    *ngIf="priority.value.id !== 0 || editMode"
    class="priority-info-container"
  >
    <div *ngIf="priority.value.id !== 0 && !editMode" class="priority-info">
      <table>
        <tr>
          <td>
            <strong>{{ "priorityDetails.nameLabel" | translate }}:</strong>
          </td>
          <td class="td">{{ priority.value.value }}</td>
        </tr>
        <tr>
          <td>
            <strong>{{ "priorityDetails.colorLabel" | translate }}:</strong>
          </td>
          <td>
            <span
              [style.background-color]="priority.value.color"
              class="color-preview"
            ></span>
            {{ priority.value.color }}
          </td>
        </tr>
        <tr>
          <td>
            <strong
              >{{ "priorityDetails.importanceLabel" | translate }}:</strong
            >
          </td>
          <td class="td">{{ priority.value.importance }}</td>
        </tr>
      </table>

      <div *ngIf="supervisor" class="btn">
        <button class="btn-edit" (click)="toggleEditMode()">
          <span class="material-icons-outlined">edit</span>
          {{ "priorityDetails.editButton" | translate }}
        </button>
        <button class="btn-delete" (click)="deletePriority()">
          <span class="material-icons-outlined">delete</span>
          {{ "priorityDetails.deleteButton" | translate }}
        </button>
      </div>
      <messages
        class="message"
        [form]="priorityForm"
        [messagesObserver]="messages"
        [showNonFieldKeys]="TRUE"
        [showFieldName]="TRUE"
        [showFieldKeys]="FALSE"
      ></messages>
    </div>
    <form [formGroup]="priorityForm" *ngIf="editMode">
      <div class="form-group">
        <label for="name">{{ "priorityDetails.nameLabel" | translate }}:</label>
        <input type="text" id="name" formControlName="name" />
        <messages
          class="msg"
          [form]="priorityForm"
          [messagesObserver]="messages"
          fieldname="name"
        ></messages>

        <div class="color">
          <label for="color"
            >{{ "priorityDetails.colorLabel" | translate }}:</label
          >
          <input type="color" id="color" formControlName="color" />
        </div>
      </div>
      <div class="form-group">
        <label>{{ "priorityDetails.importanceLabel" | translate }}:</label>
        <div class="radio-group">
          <label *ngFor="let num of [1, 2, 3, 4, 5]">
            <input type="radio" [value]="num" formControlName="importance" />
            {{ num }}
          </label>
        </div>
      </div>

      <div class="action-buttons">
        <action-button
          class="save"
          (actionEvent)="savePriority($event)"
          label="{{ 'priorityDetails.saveButton' | translate }}"
        >
          <span class="material-icons-outlined">save</span>
          {{ "priorityDetails.saveButton" | translate }}
        </action-button>

        <button type="button" class="btn-cancel" (click)="toggleEditMode()">
          <span class="material-icons-outlined">cancel</span>
          {{ "priorityDetails.cancelButton" | translate }}
        </button>
      </div>
      <messages
        class="message"
        [form]="priorityForm"
        [messagesObserver]="messages"
        [showNonFieldKeys]="TRUE"
        [showFieldName]="TRUE"
        [showFieldKeys]="FALSE"
      ></messages>
    </form>
  </div>
</div>
